import { render, staticRenderFns } from "./cancelOrder.vue?vue&type=template&id=6fc97848&"
import script from "./cancelOrder.vue?vue&type=script&lang=js&"
export * from "./cancelOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports